import Vue from 'vue'
import axios from 'axios'
import {ERR_OK} from 'api/config'
// import Promise from 'es6-promise'
// Promise.polyfill()

Vue.prototype.axios = axios


export default function ajaxGetRequest(url, data) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: url,
      params: data
    }).then((res) => {
      if (res.data.code === ERR_OK) {
        resolve(res.data)
      } else {
        resolve(res.data)
      }
    }).catch(
      (res)=>{
        console.log(res)
      }
    //   (res) => {
      //   reject(res)
      // }
    )
  })
}



// WEBPACK FOOTER //
// ./src/common/js/ajaxGetRequest.js